import { render, staticRenderFns } from "./rankBoard.vue?vue&type=template&id=1cc2f259&"
import script from "./rankBoard.vue?vue&type=script&lang=js&"
export * from "./rankBoard.vue?vue&type=script&lang=js&"
import style0 from "./rankBoard.vue?vue&type=style&index=0&id=1cc2f259&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports